import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import TextInput from "./TextInput";
import StateInput from "./StateInput";
import WizardFooter from "./WizardFooter";
import { felonyConsideration } from "../utils/surveyLogic";

export const fields = [
  "convicted_of_felony",
  "convictionMonth",
  "convictionYear",
  "releaseMonth",
  "releaseYear",
  "state_or_federal_conviction",
  "court_city_or_county",
  "conviction_state",
];

const validate = (values, props) => {
  const errors = {};
  if (felonyConsideration(values)) {
    if (!values.state_or_federal_conviction) {
      errors.state_or_federal_conviction = props.allText.shared.required;
    }
    if (!values.court_city_or_county) {
      errors.court_city_or_county = props.allText.shared.required;
    }
    if (!values.conviction_state) {
      errors.conviction_state = props.allText.shared.required;
    }
  }
  return errors;
};

export class WizardFormSection06b extends Component {
  componentDidMount() {
    const {
      fields: {
        convicted_of_felony,
        convictionMonth,
        convictionYear,
        releaseMonth,
        releaseYear,
      },
      handleSubmit,
    } = this.props;
    if (
      !felonyConsideration({
        convicted_of_felony: convicted_of_felony.value,
        convictionMonth: convictionMonth.value,
        convictionYear: convictionYear.value,
        releaseMonth: releaseMonth.value,
        releaseYear: releaseYear.value,
      })
    ) {
      handleSubmit();
    }
  }

  render() {
    const {
      allText,
      fields: {
        state_or_federal_conviction,
        court_city_or_county,
        conviction_state,
      },
      handleSubmit,
      previousPage,
    } = this.props;
    const text = { ...allText.shared, ...allText.section06b };
    const progress = 5;
    return (
      <form onSubmit={handleSubmit} className="form-horizontal">
        <div className="wizard-page-content">
          <div className="page-title-container">
            <span className="page-title underline">{text.title}</span>
            <span className="wizard-text question-text">{text.subtitle}</span>
          </div>
          <div className="primary-question">{text.primaryQuestion}</div>
          <div className="separator" />
          <div className="row">
            <div className="col-12 col-sm-4">
              <div className="wizard-text">{text.question04}</div>
              <RadioInput
                text={text}
                field={state_or_federal_conviction}
                options={["state", "federal"]}
              />
            </div>

            <div className="col-12 col-sm-4">
              <div className="wizard-text">{text.question05}</div>
              <TextInput
                text={text}
                field={court_city_or_county}
                placeholder={text.question05Placeholder}
              />
            </div>

            <div className="col-12 col-sm-4">
              <div className="wizard-text">{text.question06}</div>
              <StateInput
                text={text}
                field={conviction_state}
                placeholder={text.question06Placeholder}
              />
            </div>
          </div>
        </div>
        <WizardFooter
          text={text}
          previousPage={previousPage}
          progress={progress}
        />
      </form>
    );
  }
}

WizardFormSection06b.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection06b);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection06b.js